import React from "react";
import { Icon } from "semantic-ui-react";
import SearchInput from "../../../SearchInput";

function SearchBar(props) {
  return (
    <div className="-search-wrapper">
      <div className="-search-form" action="" autoComplete="off">
        <SearchInput className="-search-input" name="search" placeholder="What're we looking for?" />
        <button className="-search-button" type="submit">
          <Icon name="search" className="-search-icon" />
        </button>
      </div>
    </div>
  );
}

export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/Header/Components/SearchBar/index.js